import { render } from "./TablaCursosDiplomas.vue?vue&type=template&id=11450ce2&ts=true"
import script from "./TablaCursosDiplomas.vue?vue&type=script&lang=ts"
export * from "./TablaCursosDiplomas.vue?vue&type=script&lang=ts"

import "./TablaCursosDiplomas.vue?vue&type=style&index=0&id=11450ce2&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__